<div
    class="st-tile-view-container"
    cdkDropListGroup
    cdkVirtualScrollingElement>
    @for (column of tileViewColumns$ | ngrxPush; track column.value) {
        <st-tile-column
            class="st-tile-view-day-column"
            cdkDropList
            [totalCols]="7"
            [column]="column"
            [itemTemplate]="itemTemplate"
            [objectName]="objectName"
            [childObjectName]="childObjectName"
            [cdkDropListEnterPredicate]="onEnterPredicate(column)"
            (createTopic)="createTopicInGroup(column)"
            (cdkDropListDropped)="moveTopicInGroup($event, column)" />
    }
</div>
